import Button from '@components/v2/ui/Button/Button';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import LangEnum from '../../../lang/LangEnum';
import { OrderView } from '../../../modules/orders/ordersView.types';
import { useTranslation } from '../../../modules/translation/TranslationContext';
import useGeneralSettingsStore from '../../../stores/GeneralSettings/useGeneralSettingsStore';
import useOrderBookStore from '../../../stores/OrderBook/orderBook.store';
import useProductActionsStore from '../../../stores/ProductActionsStore/productActions.store';
import snackbarStore from '../../../stores/Snackbar.store';
import { useProductNotificationStyles } from '../styles/ProductNotificationStyles';
import { useProductNotificationHighlight } from './useProductNotificationHighlight';

const PRODUCT_ALREADY_ADDED_SNACKBAR_ID = 'product-already-added';

const closeAlreadyAddedNotification = () => {
  const { productNotificationState, closeProductNotification } = useProductActionsStore.getState();

  if (productNotificationState.productAlready) {
    closeProductNotification();
  }
};

export const useProductAlreadyAddedSnackbar = () => {
  const { productNotificationState, setNotificationTimerIsValid, setScrollToProduct } =
    useProductActionsStore(
      useShallow((state) => ({
        productNotificationState: state.productNotificationState,
        setNotificationTimerIsValid: state.setNotificationTimerIsValid,
        setScrollToProduct: state.setScrollToProduct,
      })),
    );

  const selectedOrder = useOrderBookStore((state) => state.selectedOrder);
  const history = useHistory();
  const { translate } = useTranslation();
  const mediaFormat = useGeneralSettingsStore((state) => state.generalSettings.mediaFormat);
  const { classes } = useProductNotificationStyles({ mediaFormat });

  useProductNotificationHighlight(productNotificationState.productAlready);

  useEffect(
    () => () => {
      snackbarStore.close(PRODUCT_ALREADY_ADDED_SNACKBAR_ID);
    },
    [],
  );

  useEffect(() => {
    if (!productNotificationState.productAlready) {
      snackbarStore.close(PRODUCT_ALREADY_ADDED_SNACKBAR_ID);
      return;
    }

    const handleRedirectToOrder = () => {
      if (!selectedOrder) {
        return;
      }

      history.push(`/orders/${selectedOrder.id}/${OrderView.EDIT}`);
      setNotificationTimerIsValid(true);
      setScrollToProduct(true);
    };

    snackbarStore.showCustom({
      id: PRODUCT_ALREADY_ADDED_SNACKBAR_ID,
      onClose: closeAlreadyAddedNotification,
      content: (
        <Stack
          direction="row"
          className={classes.productAlreadySnackbar}
          sx={{ justifyContent: 'space-between', alignItems: 'center' }}
        >
          <Typography variant="body2" color="text.secondary">
            {productNotificationState.productColorId
              ? translate(LangEnum.PRODUCT_NOTIFICATION_ALREADY_ADDED)
              : translate(LangEnum.PRODUCT_KIT_NOTIFICATION_ALREADY_ADDED)}
          </Typography>
          <Button variant="text" color="primary" size="small" onClick={handleRedirectToOrder}>
            {translate(LangEnum.PRODUCT_NOTIFICATION_VIEW_ON_ORDER)}
          </Button>
        </Stack>
      ),
    });
  }, [
    productNotificationState,
    selectedOrder,
    history,
    translate,
    classes,
    setNotificationTimerIsValid,
    setScrollToProduct,
  ]);
};
